<template>
    <b-card>
    <div class="form-group" v-if="m_isAdmin()">
      <label for="company" class="label">Company <span class="required">*</span></label>
      <div class="input-wrapper">
        <v-select
          v-model="selectedCountry"
          :options="countries"
          label="name"
          :reduce="c => c.code"
          placeholder=""
          class="country-flag-select"
          :clearable="false"
        >
          <template #option="{ code, name }">
            <div class="d-flex align-items-center">
              <img :src="getFlagSrc(code)" class="flag-icon mr-2" />
              <span class="country-name">{{ name }}</span>
            </div>
          </template>
          <template #selected-option="{ code }">
            <div class="d-flex align-items-center justify-center">
              <img :src="getFlagSrc(code)" class="flag-icon" />
            </div>
          </template>
        </v-select>
        <div class="input-divider"></div>
        <v-select
          v-model="selectedCompany"
          :options="filteredCompanies"
          label="name"
          :reduce="c => c.id"
          class="company-name-select"
          :disabled="!selectedCountry"
          placeholder="Seleccione company"
        >
          <template #no-options>
            <div class="no-options">
              <span>No hay companies disponibles para el país seleccionado</span>
            </div>
          </template>
        </v-select>
      </div>
    </div>


    <b-tabs align="left" class="tab-primary" v-model="tabIndex" :key="keyAuditorConnct">
      <b-tab title="Consulta">
        <billing :goToTab="goToTab"></billing>
      </b-tab>
      <b-tab :title="'Tarifas'" lazy>
        <tariffs></tariffs>
      </b-tab>
    </b-tabs>
    </b-card>
</template>
<script>
import billing from './billing'
import tariffs from './tariffs'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  components: { billing, tariffs, vSelect },
  name: 'AuditorConnect',
  data () {
    return {
      tabIndex: 0,
      keyAuditorConnct: 0,
      isTariffs: false,
      adminData: '',
      companyData: null,
      selectedCountry: null,
      selectedCompany: null,
      countries: [{
        code: 'CL',
        name: 'Chile'
      },
      {
        code: 'PE',
        name: 'Perú'
      },
      {
        code: 'AR',
        name: 'Argentina'
      },
      {
        code: 'CO',
        name: 'Colombia'
      },
      {
        code: 'MX',
        name: 'México'
      }, {
        code: 'EC',
        name: 'Ecuador'
      }, {
        code: 'UY',
        name: 'Uruguay'
      }, {
        code: 'US',
        name: 'Estados Unidos'
      }
      ]
    }
  },
  computed: {
    filteredCompanies () {
      return this.companies.map(company => company.company)
    },
    ...mapGetters({
      companies: 'getCompaniesDeliveryConnect'
    })
  },
  watch: {
    companies: {
      handler(newVal) {
        if (newVal) {
          this.companyData = newVal
        }
      },
      immediate: true
    },
    selectedCountry: {
      handler(newVal) {
        if (newVal) {
          this.getCompaniesConnect()
          this.selectedCompany = null
        }
      },
      immediate: true
    },
    selectedCompany: {
      handler(newVal) {
        if (newVal) {
          const queryParams = {}
          const params = {
            company_id: newVal
          }
          this.$store.dispatch('fetchService', { name: 'getCompaniesConnect', queryParams, params })
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.selectedCountry = 'CL'
  },
  methods: {
    setInitialAll() {
      if (this.m_isAdmin()) {
        this.selectedCountry = 'CL'
      } else {
        const queryParams = {}
        const params = {
          company_id: 1162
        }
        this.$store.dispatch('fetchService', { name: 'getCompaniesConnect', queryParams, params })
      }
    },
    goToTab(index) {
      this.tabIndex = index
    },
    getFlagSrc(code) {
      return require(`@/assets/images/flags/${code.toLowerCase()}.png`)
    },
    getCompaniesConnect() {
      const queryParams = {
        'filter[activationStatus]': 1,
        'filter[countryCode]': this.selectedCountry
      }
      const params = {}
      this.$store.dispatch('fetchService', { name: 'getCompaniesDeliveryConnect', queryParams, params })
    }
  }
}
</script>
<style lang='scss'>
.admin-input-container {
  padding: 0 1rem;
}
.admin-input {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #f9f9fd;
}

.admin-input-container {
  padding: 0 1rem;
}
.fieldSelect--img {
  width: 1.5rem;
  margin-right: 0.5rem;
}


.custom-select-wrapper {
  position: relative;
}

.custom-select {
  border-radius: 10px;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border: 1px solid #dce1e7;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}
.form-label {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.4rem;
  display: block;
}

.input-wrapper {
  display: flex;
  gap: 0;
  max-width: 24rem;
}

.input-divider {
  width: 1px;
  background-color: #EAECED;
  height: auto;
  align-self: stretch;
  margin: 0;
}

.country-flag-select {
  max-width: 5rem;
  min-width: 5rem;
  background: transparent;
  .vs__dropdown-toggle {
    border-right: none !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
}

.company-name-select {
  flex-grow: 1;
  border: none;
  background: transparent;

  .vs__dropdown-toggle {
    border-left: none !important;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}

.flag-icon {
  width: 24px;
  height: 16px;
  object-fit: contain;
}

.country-name {
  font-size: 0.775rem;
  font-weight: 600;
}

.required {
  color: red;
}

</style>